module.exports = __webpack_public_path__ + "static/media/teeth.c10e0faf.svg";